import { TimelineRange } from "@/components/Molecules/TimelineRange";
import { TimelineVertical } from "@/components/Molecules/TimelineVertical";
import { cva } from "class-variance-authority";
import { getSectionMarginClasses } from "@/lib/section-margins";

const TimelineVariants = cva(
	`relative container mx-auto w-full max-w-[72rem]`,
	{
	variants: {
		layout: {
			full: "",
			container: "",
		},
	},
	defaultVariants: {},
});

export default function SectionTimeline(data: any) {
	return (
		<div
			className="relative"
			style={{ backgroundColor: data?.blockBackgroundColor?.color?.hex }}
		>
			<div
				className={`${TimelineVariants({
					layout: data?.layout,
				})} ${getSectionMarginClasses({
					useSectionMargins: data?.useSectionMargins,
					useExtraTopMargins: data?.useExtraTopMargins,
					useExtraBottomMargins: data?.useExtraBottomMargins,
				})}`}
			>
				{data.timelineType === "default" ? (
					<TimelineRange
						historyMoments={data.historyMoments}
						textColor={data?.textColor?.color}
						title={data.title}
						titleColor={data.titleColor?.color}
						yearColor={data?.yearColor?.color}
					/>
				) : (
					<TimelineVertical
						historyMoments={data.historyMoments}
						textColor={data?.textColor?.color}
						title={data.title}
						titleColor={data.titleColor?.color}
						yearColor={data?.yearColor?.color}
						titleHistoryColor={data.titleHistoryColor?.color}
					/>
				)}
			</div>
		</div>
	);
}

export const fragment = `
fragment SectionTimelineFragment on SectionTimelineRecord {
	id
    title
	layout
	timelineType
    useExtraBottomMargins
    useExtraTopMargins
    useSectionMargins
    historyMoments {
      id
      year
	  title
	  addRangeOfYears
	  rangeYear
      description
      image {
        url
        alt
        format
        width
        height
        responsiveImage(imgixParams: { auto: format }) {
          ...responsiveImageFragment
        }
      }
      companionImage {
        url
        alt
        format
        width
        height
        responsiveImage(imgixParams: { auto: format }) {
          ...responsiveImageFragment
        }
      }
    }
	titleColor {
		color {
		  hex
		}
	  }
	titleHistoryColor {
		color {
		  hex
		}
	  }
	yearColor {
		color {
		  hex
		}
	  }
	textColor {
		color {
		  hex
		}
	  }
	blockBackgroundColor {
		color {
		  hex
		}
	  }
  }
  `;
